import { outOfBandThemeColors } from '@/theme/colors';
import { Box, Stack } from '@montugroup/design-system';
import { styled } from '@mui/material';
import { StyledLandingComponentContainer, StyledLandingComponentContentWrapper } from './LandingStyles';

export const StyledSubmitSectionBackground = styled(Box)(() => ({
  width: '100%',
  backgroundColor: outOfBandThemeColors.uMeds.merino300,
}));

export const StyledSubmitSectionContainer = styled(StyledLandingComponentContainer)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    paddingTop: theme.spacing(3.5),
    paddingBottom: 0,
  },
}));

export const StyledTokenInputContainer = styled(Box)(({ theme }) => ({
  background: theme.palette.common.white,
  borderRadius: theme.spacing(4),
  border: `1px solid ${outOfBandThemeColors.uMeds.merinoDark}`,
  padding: `${theme.spacing(8)} ${theme.spacing(6)}`,
  width: '100%',
  height: 'auto',
  [theme.breakpoints.up('md')]: {
    padding: `${theme.spacing(8)} ${theme.spacing(10)}`,
    width: '100%',
    height: 'auto',
    maxWidth: theme.spacing(167),
  },
}));

export const StyledSubmitSectionImage = styled('img')(({ theme }) => ({
  display: 'none',
  [theme.breakpoints.up('md')]: {
    display: 'block',
    width: theme.spacing(104),
    height: 'auto',
  },
}));

export const StyledSubmitSectionContentWrapper = styled(StyledLandingComponentContentWrapper)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    paddingTop: theme.spacing(16.5),
    paddingBottom: theme.spacing(13.5),
    gap: theme.spacing(6),
  },
}));

export const SubmitTokenTextWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: theme.spacing(4),
}));

export const StyledTokenInputWrapper = styled(Stack)(() => ({
  alignItems: 'flex-start',
  width: '100%',
}));
